import OnboardingCard from "./OnboardingCard";
export default OnboardingCard;
